import { render, staticRenderFns } from "./VideoElections2023.vue?vue&type=template&id=128ba08f&"
import script from "./VideoElections2023.vue?vue&type=script&lang=js&"
export * from "./VideoElections2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128ba08f')) {
      api.createRecord('128ba08f', component.options)
    } else {
      api.reload('128ba08f', component.options)
    }
    module.hot.accept("./VideoElections2023.vue?vue&type=template&id=128ba08f&", function () {
      api.rerender('128ba08f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/video-elections-2023/VideoElections2023.vue"
export default component.exports